export default function AuditMetadata({createdAt, updatedAt}: {
    createdAt?: Date;
    updatedAt?: Date;
}) {
    return (
        <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-muted-foreground">
            <span><span className="font-medium text-foreground">Erstellt:</span> {formatDate(createdAt)}</span>
            <span><span className="font-medium text-foreground">Aktualisiert:</span> {formatDate(updatedAt)}</span>
        </div>
    );
}

function formatDate(date?: Date) {
    return date?.toLocaleString("de-DE") ?? "–";
}
